import { createContext, useContext } from 'react';

type IOC<T = unknown> = T | null;

export const IOCContext = createContext<IOC>(null);

export const useIOC = () => {
  return useContext(IOCContext);
};
